import IAuthorizationData from "../../../core/src/server/data/IAuthorizationData";
import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";

import { AuthResponse, InfoResponse } from "../FTypes";

export default class AuthorisationDataParser
    implements IBaseDataParser<IAuthorizationData>
{
    check(data: InfoResponse<unknown> & AuthResponse): boolean {
        return !!data?.settings && !!data?.currency;
    }

    parse(data: InfoResponse<unknown> & AuthResponse): IAuthorizationData[] {
        const result: IAuthorizationData = {
            playerConfig: {
                userId: data.settings.wallet,
                isDemoPlayer: data.settings.operator === "demo",
                currency: data.currency,
            },
        };

        return [result];
    }
}
